import React from 'react';
import { CompanyRegistration, CompanyRegistrationErrors } from '../../../types';

interface AccessInfoSectionProps {
  formData: Partial<CompanyRegistration>;
  errors: CompanyRegistrationErrors;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
}

const AccessInfoSection: React.FC<AccessInfoSectionProps> = ({
  formData,
  errors,
  onInputChange
}) => {
  return (
    <>
      <h3 className="uk-heading-small uk-margin-small-top">Información de Acceso</h3>
      
      <div className="uk-margin-small">
        <label className="uk-form-label" htmlFor="usuario">Email de Usuario *</label>
        <div className="uk-form-controls">
          <input 
            className={`uk-input ${errors.usuario ? 'uk-form-danger' : ''}`}
            id="usuario" 
            name="usuario"
            type="email" 
            placeholder="tu@email.com" 
            value={formData.usuario || ''}
            onChange={onInputChange}
            required 
            style={{ color: '#333', backgroundColor: '#fff' }}
          />
          {errors.usuario && (
            <div className="uk-text-danger uk-text-small">{errors.usuario}</div>
          )}
        </div>
      </div>
      
      <div className="uk-grid uk-grid-small" data-uk-grid>
        <div className="uk-width-1-2@m">
          <div className="uk-margin-small">
            <label className="uk-form-label" htmlFor="password">Contraseña *</label>
            <div className="uk-form-controls">
              <input 
                className={`uk-input ${errors.password ? 'uk-form-danger' : ''}`}
                id="password" 
                name="password"
                type="password" 
                placeholder="Mínimo 8 caracteres" 
                value={formData.password || ''}
                onChange={onInputChange}
                required 
                style={{ color: '#333', backgroundColor: '#fff' }}
              />
              {errors.password && (
                <div className="uk-text-danger uk-text-small">{errors.password}</div>
              )}
            </div>
          </div>
        </div>
        
        <div className="uk-width-1-2@m">
          <div className="uk-margin-small">
            <label className="uk-form-label" htmlFor="confirm-password">Reingrese la Contraseña *</label>
            <div className="uk-form-controls">
              <input 
                className={`uk-input ${errors.confirmPassword ? 'uk-form-danger' : ''}`}
                id="confirm-password" 
                name="confirmPassword"
                type="password" 
                placeholder="Repite tu contraseña" 
                value={formData.confirmPassword || ''}
                onChange={onInputChange}
                required 
                style={{ color: '#333', backgroundColor: '#fff' }}
              />
              {errors.confirmPassword && (
                <div className="uk-text-danger uk-text-small">{errors.confirmPassword}</div>
              )}
            </div>
          </div>
        </div>
      </div>
      
      <div className="uk-margin-small">
        <label className="uk-form-label">
          <input 
            className="uk-checkbox" 
            type="checkbox" 
            name="terminos"
            checked={formData.terminos || false}
            onChange={onInputChange}
            required 
          />
          Acepto los <button type="button" className="uk-link uk-button-text">Términos y Condiciones</button> y la <button type="button" className="uk-link uk-button-text">Política de Privacidad</button>
        </label>
        {errors.terminos && (
          <div className="uk-text-danger uk-text-small">{errors.terminos}</div>
        )}
      </div>
    </>
  );
};

export default AccessInfoSection;
